import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { Modal } from "react-bootstrap";
import AlertModal from "./AlertModal";
import "./Modal.css";
import "./AiDialog.css";
import PromptModal from "./PromptModal";
import MultiSelectModal from "./MultiSelectModal";
import Place, { Place_Source } from "../../Models/Place";
import Common, { AICategories, AIBaseCategories, API_BASE_URL, describeAIResponseError } from "../../Common/Common";
import Appointment from "../../Models/Event";
import { DateTime } from "luxon";
import GooglePlaces from "../../Models/GooglePlaces";
import GoogleSearch from "../../Models/GoogleSearch";
import { hasRealPhoto } from "../../Common/placeEnrichment";
import { applyAIBestTime } from "../../Common/aiDaySchedule";
import { countries } from "../../Data/Countries";
import { citiesByCountry } from "../../Data/Cities";

const icoRobot = solid("robot");
const icoChevDown = solid("chevron-down");
const icoChevUp = solid("chevron-up");

// Highest Number option; also the hard cap on places processed per AI
// search, since each place triggers paid lookups.
const MAX_AI_SEARCH_RESULTS = 20;

class AISearch extends Component {
  constructor(props) {
    super(props);
    let city = "Florence";
    let country = "Italy";
    let attributes = window.guide_obj.attributes;
    if (attributes.cities.length > 0) {
      city = attributes.cities[0];
    }
    if (attributes.countries.length > 0) {
      country = attributes.countries[0];
    }
    let place = null;
    if (typeof this.props.id !== "undefined") {
      place = window.guide_obj.places.getPlace(this.props.id);
    }
    let location = null;
    if (typeof this.props.location !== "undefined") {
      location = this.props.location;
    }
    //console.log("this.props.location", this.props.location);
    //console.log("location", location);
    let curDate = DateTime.now().toISO({ zone: "utc" });
    curDate = DateTime.fromISO(curDate, { zone: "utc" });
    curDate = curDate.set({ hour: 9 });
    curDate = curDate.set({ minute: 0 });
    this.state = {
      wizardStep: 0,
      selectedQuestion: "When is the best time to visit Florence",
      selectedNumber: "3",
      selectedCity: city,
      selectedCountry: country,
      place: place,
      location: location,
      LatLong: "0,0",
      mood: "standard",
      radius: "50Km",
      proximity: "in",
      Schedule: "",
      ScheduleText: "",
      Places: "",
      PlacesArray: [],
      PlacesFound: [],
      answer: "",
      statusText: "",
      totalPlacesToFind: 0,
      SearchText: "",
      excludeGuidePlaces: true,
      searchArea: this.props.mapBounds ? "map" : "place",
      customSearch: "",
      optionsOpen: false,
      dateStart: curDate,
      AICategories: [],
      AIBaseCategories: [],

      AlertModalShow: false,
      activityIndicator: false,
      AlertModalTitle: "",
      AlertModalMessage: "",
      AlertModalButtons: [],

      PromptModalShow: false,
      PromptModalTitle: "Enter Value",
      PromptModalMessage: "",
      PromptModalButtons: [],
      PromptModalInputs: [],

      MultiselectItems: [],
      MultiselectSelectedItems: [],
      MultiselectMode: "uni",
      MultiselectCallback: null,
      MultiselectTitle: "Select",
      MultiselectSearchText: "",
      ShowMultiselect: false,
    };
  }
  componentDidMount() {
    let _AICategories = [];
    let _AIBaseCategories = [];
    try {
      _AICategories = JSON.parse(this.props.ai_categories);
    } catch (e) {
      console.log("Error parsing this.props.ai_categories");
      _AICategories = AICategories;
    }
    try {
      _AIBaseCategories = JSON.parse(this.props.ai_base_categories);
    } catch (e) {
      console.log("Error parsing this.props.ai_base_categories");
      _AIBaseCategories = AIBaseCategories;
    }
    this.setState({ AICategories: _AICategories, AIBaseCategories: _AIBaseCategories });
    if (this.props.autoQuestion) {
      // Keep the visible "Number" field and the canned-question list's own
      // "Top N ..." substitution consistent with what's actually being asked
      // — otherwise they keep showing the state default ("3") regardless of
      // the real count embedded in autoQuestion.
      const match = this.props.autoQuestion.match(/\d+/);
      this.setState({
        selectedQuestion: this.props.autoQuestion,
        selectedNumber: match ? match[0] : this.state.selectedNumber,
        answer: "",
        statusText: "Step 1 of 4: Asking AI for places…",
        activityIndicator: true,
      });
      this.askQuestion(this.props.autoQuestion, null);
    }
  }

  _user_info = null;
  MyAlert = (title, message) => {
    if (typeof message === "undefined") message = "";
    this.setState({
      AlertModalTitle: title,
      AlertModalMessage: message,
      AlertModalButtons: [{ Title: "OK", Method: null }],
      AlertModalShow: true,
    });
  };

  // modifyCity = () => {
  //   this.setState({
  //     PromptModalShow: true,
  //     PromptModalTitle: "City",
  //     PromptModalMessage: "Enter city Name",
  //     PromptModalButtons: [
  //       { Title: "OK", Method: this.ModifyCityCallback },
  //       { Title: "CANCEL", Method: null },
  //     ],
  //     PromptModalInputs: [{ name: "City Name", value: this.state.selectedCity }],
  //   });
  // };

  // ModifyCityCallback = (inputs) => {
  //   if (inputs === null) return;
  //   let city = inputs[0].value;
  //   this.setState({ selectedCity: city });
  // };

  // modifyCountry = () => {
  //   this.setState({
  //     PromptModalShow: true,
  //     PromptModalTitle: "Country",
  //     PromptModalMessage: "Enter Country Name",
  //     PromptModalButtons: [
  //       { Title: "OK", Method: this.ModifyCountryCallback },
  //       { Title: "CANCEL", Method: null },
  //     ],
  //     PromptModalInputs: [{ name: "Country Name", value: this.state.selectedCountry }],
  //   });
  // };

  // ModifyCountryCallback = (inputs) => {
  //   if (inputs === null) return;
  //   let country = inputs[0].value;
  //   this.setState({ selectedCountry: country });
  // };

  numberChanged = (e) => {
    this.setState({ selectedNumber: e.target.value });
  };

  moodChanged = (e) => {
    this.setState({ mood: e.target.value });
  };

  radiusChanged = (e) => {
    this.setState({ radius: e.target.value });
  };

  LatLongChanged = (e) => {
    this.setState({ LatLong: e.target.value });
  };

  handleChangeSchedule = (e) => {
    this.setState({ Schedule: e.target.value });
  };

  handleChangePlaces = (e) => {
    this.setState({ Places: e.target.value });
  };

  // Free-text "Describe what you're looking for" — built in the same shape
  // as the preset questions so it runs through the identical places-JSON
  // pipeline (askQuestion / _askMapAreaQuestion). Off-topic text simply
  // yields no usable places, reported via the _customSearch flag below.
  runCustomSearch = () => {
    const text = this.state.customSearch.trim().replace(/[."']+$/g, "");
    if (text === "" || this.state.activityIndicator) return;
    const n = this.state.selectedNumber;
    // "Top N" is added only if the text doesn't already start with it, and
    // the location only if the text doesn't already name the city — so a
    // filled-in sample ("Top 10 day trips from Florence Italy") is sent as
    // written, keeping wording like "from"/"outside of".
    // "Top N" is capped at MAX_AI_SEARCH_RESULTS — each place found costs
    // paid lookups (place search, hours, photo), so "Top 10000000" must not
    // become hundreds of them.
    const base = /^top\s+\d+\b/i.test(text)
      ? text.replace(/^top\s+(\d+)/i, (m, num) => `Top ${Math.max(1, Math.min(MAX_AI_SEARCH_RESULTS, parseInt(num, 10)))}`)
      : `Top ${n} ${text}`;
    const city = (this.state.selectedCity || "").toLowerCase();
    let quest;
    if (this.state.searchArea === "map" && this.props.mapBounds) quest = base;
    else if ((city !== "" && text.toLowerCase().includes(city)) || /\b(in|near|around|from|outside of|close to)\s+[A-ZÀ-Þ]/.test(text)) quest = `${base}.`;
    else if (this.state.place) quest = `${base} ${this.state.proximity} ${this.state.place.Name}, ${this.state.selectedCity} ${this.state.selectedCountry}.`;
    else quest = `${base} ${this.state.proximity} ${this.state.selectedCity} ${this.state.selectedCountry}.`;
    this.questionChanged({ target: { value: quest }, custom: true });
  };

  _noCustomResults = () => {
    this._customSearch = false;
    this.setState({ activityIndicator: false, statusText: "" });
    this.MyAlert("No places found — try describing the kind of places you want, e.g. \"romantic restaurants with a view\".");
  };

  // The search box, spinner and response sit at the top of the scrollable
  // body — bring them into view when a search starts or a sample is picked.
  _scrollToTop = () => {
    if (this._bodyRef) this._bodyRef.scrollTo({ top: 0, behavior: "smooth" });
  };

  questionChanged = (e) => {
    let quest = e.target.value;
    if (quest === "Choose a question") return;
    this._scrollToTop();
    this._customSearch = e.custom === true;
    this.setState({ selectedQuestion: quest, answer: "", statusText: "", activityIndicator: true });
    this.askQuestion(quest, null);
  };
  // Excludes both real guide places AND places already sitting in the
  // current search results (pending "+" add) — a place doesn't stop being
  // "already found" just because the user hasn't confirmed adding it yet,
  // and without this a repeated/overlapping query kept re-suggesting names
  // that were then silently deduped client-side with a confusing "no new
  // places" message instead of the AI just not proposing them again.
  _buildExclusionClause = () => {
    if (!this.state.excludeGuidePlaces) return "";
    const guideNames = (window.guide_obj?.places?.placesList || []).map((p) => p.Name);
    const searchResultNames = this.props.search_results_names || [];
    const existingNames = [...new Set([...guideNames, ...searchResultNames])]
      .filter((n) => n && n.trim() !== "")
      .join(", ");
    // Worded so "Top N" still means N NEW places: a bare "Exclude these"
    // made the model pick its top N and then drop the excluded ones (e.g.
    // "Top 10 attractions" with 7 already in the guide returned only 3).
    // Found 2026-10-07.
    return existingNames
      ? ` These places are already in the guide, so do not include any of them: ${existingNames}. Still return the full number of places requested, choosing the next-best places that are not in that list.`
      : "";
  };

  askQuestion = (quest, callback) => {
    if (this.state.searchArea === "map" && this.props.mapBounds) {
      this._askMapAreaQuestion(quest);
      return;
    }
    // Same exclusion convention as Map.js's "Additional must see" — tell the
    // AI directly which names to skip, rather than filtering client-side
    // (the model can then use the room to suggest that many more real
    // alternatives instead of just returning a shorter list).
    let exclusion = this._buildExclusionClause();
    // Typed (free-text) searches only: a request that isn't a place search
    // should come back empty rather than as place-shaped nonsense.
    const notPlacesGuard = this._customSearch ? " If this request is not a search for physical places to visit, return an empty JSON array [] instead." : "";
    quest =
      `schedule for ` +
      quest +
      exclusion +
      notPlacesGuard +
      //` Respond in json format with attributes: 'Attraction', 'Category' and 'Description' for each entry`;
      ` Provide the response in JSON, following this format without deviation.
    [{
      'Attraction': 'the name of the attraction',
      'City': 'the city in which the attraction is located',
      'Category': 'the category of the attraction',
      'Description': 'a description of the attraction'
      'Duration': a bare integer number of minutes to visit the attraction, e.g. 90 — no words or units,
      'BestTime': 'morning' | 'afternoon' | 'sunset' | 'evening' | '' — the best time of day to visit, '' if it doesn't matter,
    }]`;
    //console.log("Question", quest);
    //this.MyAlert(`Question: ${quest}`);
    //quest = encodeURIComponent(quest);
    // Encoded: the prompt includes guide place names, and an unencoded "&" or
    // "#" in one cut the URL short, so the AI got half the instructions.
    var url = `${API_BASE_URL}/travel_questionsGPT5.6-luna.php?q=${encodeURIComponent(`"${quest}"`)}`;
    let _this = this;
    fetch(url)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response === null || typeof response === "undefined") {
          console.log("Error in AI response", response);
          _this.MyAlert("AI Error", describeAIResponseError(response));
          _this.setState({ activityIndicator: false });
          return;
        }
        if (response.choices === null || typeof response.choices === "undefined") {
          console.log("Error in AI answer, choices", response);
          _this.MyAlert("AI Error", describeAIResponseError(response));
          _this.setState({ activityIndicator: false });
          return;
        }
        if (response.choices.length === 0) {
          console.log("Error in AI answer, choices length", response);
          _this.MyAlert("AI Error", describeAIResponseError(response));
          _this.setState({ activityIndicator: false });
          return;
        }
        if (response.choices[0].message === null || typeof response.choices[0].message === "undefined") {
          console.log("Error in AI answer, message", response);
          _this.MyAlert("AI Error", describeAIResponseError(response));
          _this.setState({ activityIndicator: false });
          return;
        }
        if (
          response.choices[0].message.content === null ||
          typeof response.choices[0].message.content === "undefined"
        ) {
          console.log("Error in AI answer, message content", response);
          _this.MyAlert("AI Error", describeAIResponseError(response));
          _this.setState({ activityIndicator: false });
          return;
        }
        let answer = response.choices[0].message.content;
        if (answer === null || typeof answer === "undefined") {
          console.log("Error in AI answer, text");
          _this.MyAlert("AI Error", describeAIResponseError(response));
          _this.setState({ activityIndicator: false });
          return;
        }
        if (answer.startsWith("\n")) answer = answer.replace("\n", "");
        if (answer.startsWith("\n")) answer = answer.replace("\n", "");
        if (response.choices !== null) {
          const resp = _this.formatResponse(answer);
          // Hard cap regardless of what was asked or returned (see
          // MAX_AI_SEARCH_RESULTS) — protects presets and typed searches alike.
          if (Array.isArray(resp.sched_json)) resp.sched_json = resp.sched_json.slice(0, MAX_AI_SEARCH_RESULTS);
          if (resp.sched_json == null || resp.sched_json.length === 0) {
            // A typed search that found nothing stays open with a hint; a
            // preset keeps the original close-quietly behavior.
            if (_this._customSearch) {
              _this._noCustomResults();
              return;
            }
            _this.setState({ activityIndicator: false });
            _this.props.onHide();
            return;
          }
          _this.setState({
            answer: resp.sched_tex,
            totalPlacesToFind: resp.sched_json.length,
            statusText: `Step 1 of 4: Finding ${resp.sched_json.length} matching place${
              resp.sched_json.length === 1 ? "" : "s"
            } on the map…`,
          });
          _this.findAllLatLongs(resp.sched_json);
        }
        //console.log("QUESTION: ANSWER:", quest, "***", answer);
        if (callback !== null) callback(answer);
        //if (response.choices !== null) _this.setState({ answer: JSON.stringify(response), activityIndicator: false });
      })
      .catch(function (error) {
        console.log("Error in search", error);
        _this.setState({ answer: error, activityIndicator: false });
      });
  };

  // ── "Current map view" mode ──────────────────────────────────────────────
  // Ported from Map.js's "Additional must see" — same bounding-box prompt,
  // same per-place Google enrichment + category matching, so that feature
  // could be retired in favor of this being reachable from AI Search
  // directly (with a real map area available) instead of duplicating the
  // whole pipeline in a separate component.

  // Matches the AI-provided free-text Category label against the guide's
  // category taxonomy — exact name match against AICategories first, then a
  // fuzzy substring match against AIBaseCategories. Returns null (leaving the
  // place uncategorized) rather than guessing.
  _categoryIdFromLabel = (label) => {
    if (!label) return null;
    const aiCategories = this.state.AICategories || [];
    const aiBaseCategories = this.state.AIBaseCategories || [];
    let match = aiCategories.find((c) => (c.category || "").toLowerCase() === label.toLowerCase());
    if (!match) match = aiBaseCategories.find((c) => Common.tokenSubstringMatch(c.category, label));
    return match ? match.id : null;
  };

  _mapAreaQueue = { items: [], results: [], index: 0 };

  // No geocoding — the question label already had its "in/near Florence
  // Italy" clause stripped (see render()), so `quest` here is just the bare
  // topic (e.g. "Top 3 churches"). The bounding box is the only location
  // context the AI gets, exactly like the old "Additional must see."
  _askMapAreaQuestion = (quest) => {
    const bb = this.props.mapBounds;
    if (!bb) return;
    this.setState({ selectedQuestion: quest, answer: "", statusText: "Searching for places in this map area…", activityIndicator: true });

    const exclusion = this._buildExclusionClause();

    const prompt =
      `${quest}, restricted to places whose coordinates fall within this bounding box: ` +
      `south ${bb.south.toFixed(5)}, west ${bb.west.toFixed(5)}, north ${bb.north.toFixed(5)}, east ${bb.east.toFixed(5)}.` +
      exclusion +
      ` Return ONLY a JSON array with no explanation and no markdown. ` +
      `Each item: {"name":"...","lat":0.0,"lon":0.0,"description":"1-2 sentence description","category":"the category of the attraction, e.g. Museum, Park, Beach","bestTime":"morning, afternoon, sunset or evening — the best time of day to visit, \"\" if it doesn't matter"}. ` +
      `Only include places whose coordinates are inside the bounding box.` +
      (this._customSearch ? " If this request is not a search for physical places to visit, return an empty JSON array [] instead." : "");

    fetch(`${API_BASE_URL}/travel_questionsGPT5.6-luna.php?q=${encodeURIComponent(prompt)}`)
      .then((r) => r.json())
      .then((response) => {
        if (!response?.choices?.[0]?.message?.content) {
          this.setState({ activityIndicator: false, statusText: "" });
          this.MyAlert("ChatGPT did not return a valid response.");
          return;
        }
        let content = response.choices[0].message.content;
        content = content.replace(/```json\s*/gi, "").replace(/```\s*/g, "").trim();
        let items;
        try {
          items = JSON.parse(content);
          if (Array.isArray(items)) items = items.slice(0, MAX_AI_SEARCH_RESULTS);
        } catch {
          this.setState({ activityIndicator: false, statusText: "" });
          this.MyAlert("Could not parse the ChatGPT response.");
          return;
        }
        if (!Array.isArray(items) || items.length === 0) {
          this.setState({ activityIndicator: false, statusText: "" });
          this.MyAlert("ChatGPT found no places in this map area.");
          return;
        }
        const candidates = [];
        items.forEach((item) => {
          if (!item.name || item.lat == null || item.lon == null) return;
          const lat = parseFloat(item.lat);
          const lon = parseFloat(item.lon);
          if (isNaN(lat) || isNaN(lon)) return;
          if (lat < bb.south || lat > bb.north || lon < bb.west || lon > bb.east) return;
          const p = new Place();
          p.createIDFromPlacesArray(candidates);
          p.Name = item.name;
          p.Info = item.description || "";
          p.Lat = lat;
          p.Longi = lon;
          p.PType = "Icon";
          p.Points = null;
          p.Source = Place_Source.ATTRACTION;
          p._aiCategoryLabel = item.category || null;
          p._aiBestTime = item.bestTime || item.BestTime || "";
          candidates.push(p);
        });
        if (candidates.length === 0) {
          this.setState({ activityIndicator: false, statusText: "" });
          this.MyAlert("No places with valid coordinates found inside the map area.");
          return;
        }
        this._mapAreaQueue = { items: candidates, results: [], index: 0 };
        this._processNextMapAreaPlace();
      })
      .catch(() => {
        this.setState({ activityIndicator: false, statusText: "" });
        this.MyAlert("Could not reach the AI service.");
      });
  };

  // Uses searchPlacesNewAPI (provider-switchable — google/hasdata/
  // openwebninja, see PLACES_PROVIDER in Common.js) instead of the old
  // searchPlaces+getQuickDetails legacy pair, which was hardcoded to
  // Google's legacy Places API regardless of that setting — found while
  // scoping PLACES_PROVIDER coverage gaps, 2026-09-24. No aiCategories
  // passed: _finishMapAreaPlace always overwrites Category from
  // _aiCategoryLabel afterward regardless of what the search resolved, so
  // there's nothing to preserve here.
  _processNextMapAreaPlace = () => {
    const q = this._mapAreaQueue;
    if (q.index >= q.items.length) {
      this._finishMapAreaSearch();
      return;
    }
    const place = q.items[q.index];
    this.setState({
      statusText: `Looking up details & photos… (${q.index + 1}/${q.items.length}): ${place.Name}`,
    });
    const _at = new GooglePlaces();
    _at.searchPlacesNewAPI(place.Name, null, place.Lat, place.Longi, 200, (found_places) =>
      this._mapAreaGoogleCallback(found_places, place)
    );
  };

  // searchPlacesNewAPI already returns parsed Place objects — no follow-up
  // getQuickDetails pass needed.
  _mapAreaGoogleCallback = (found_places, place) => {
    // No real match: drop it rather than adding an unverified place at the
    // AI's guessed coordinates (the AI can invent or misplace places).
    if (!found_places || found_places.length === 0) {
      this._mapAreaQueue.index++;
      this._processNextMapAreaPlace();
      return;
    }
    const found = found_places[0];
    found.Info = place.Info || found.Info;
    found._aiCategoryLabel = place._aiCategoryLabel;
    found._aiBestTime = place._aiBestTime;
    this._finishMapAreaPlace(found);
  };

  _finishMapAreaPlace = (place) => {
    const q = this._mapAreaQueue;
    const categoryId = this._categoryIdFromLabel(place._aiCategoryLabel);
    if (categoryId) place.Category = [categoryId];
    delete place._aiCategoryLabel;
    applyAIBestTime(place, place._aiBestTime); // never over a BestTime the place already has
    delete place._aiBestTime;
    // Tried first now that OpenWeb Ninja/HasData is a paid subscription
    // (PLACES_PROVIDER, matching PlaceMenu.js's _autoSetPhotoSearch) — falls
    // through to the same free Custom Search chain AI Search's other photo
    // flow already uses on a miss. Added 2026-09-24.
    const paidSource = GooglePlaces.getPhotoProviderChain();
    const finishWithHours = () => {
      q.results.push(place);
      // searchPlacesNewAPI (upstream) may already have populated real hours
      // when PLACES_PROVIDER_ORDER's active provider is hasdata/openwebninja
      // (parseHasDataPlace/parseOpenWebNinjaPlace parse them straight from
      // the search response) — hasOpeningHoursData, not a bare truthy check,
      // is required since every Place starts with a fake-but-truthy "always
      // open" default. Found 2026-09-26 auditing search-then-enrich skip
      // logic; matches this file's own _fetchOpeningHoursInBackground.
      if (!GooglePlaces.hasOpeningHoursData(place.OpeningHours)) {
        GooglePlaces.fetchOpeningHours(place, (hours) => {
          if (hours) place.OpeningHours = hours;
        });
      }
      q.index++;
      this._processNextMapAreaPlace();
    };
    // Same reasoning as the hours guard above — a real photo may already be
    // sitting on `place` from the initial search (HasData/OpenWeb Ninja set
    // it directly from the vendor's own listing photo); hasRealPhoto skips
    // the paid lookup entirely when that's already true, rather than paying
    // for a photo it already has. Found 2026-09-26.
    if (hasRealPhoto(place)) {
      finishWithHours();
      return;
    }
    paidSource.searchPlacePhoto(`${place.Name} ${place.City} ${place.Country}`.trim(), (photo) => {
      if (photo) {
        place.Photo = photo;
        place.Photo_m = photo;
        finishWithHours();
        return;
      }
      GoogleSearch.searchImages(`${place.Name} near ${place.City}, ${place.Country}`, (imageList) => {
        if (imageList.length > 0) {
          place.Photo = imageList[0].url;
          place.Photo_m = imageList[0].url_m;
        }
        finishWithHours();
      });
    }, place.Lat, place.Longi);
  };

  _finishMapAreaSearch = () => {
    const q = this._mapAreaQueue;
    if (q.results.length === 0) {
      if (this.props.autoQuestion) {
        this.updateUI();
        return;
      }
      if (this._customSearch) {
        this._noCustomResults();
        return;
      }
      this.setState({ activityIndicator: false, statusText: "" });
      this.MyAlert("None of the suggested places could be found on the map in this area.");
      return;
    }
    this.setState({ activityIndicator: false, statusText: "" });
    let added = 0;
    q.results.forEach((place) => {
      if (this.props.find_search_result(place.Name) === null) {
        this.props.add_search_result(place);
        added++;
      }
    });
    if (added === 0) {
      // Every result was valid and enriched fine — they just all happen to
      // already be sitting in the current search results by name (e.g. a
      // repeated query, or overlap with an earlier search this session).
      // Distinct from the "candidates.length === 0" case above, which means
      // the AI/coordinate filter genuinely found nothing — don't reuse that
      // wording here, it read as "the search failed" when it didn't.
      this.MyAlert(
        q.results.length === 1
          ? "That place is already in your search results."
          : `All ${q.results.length} places found are already in your search results.`
      );
      return;
    }
    this.updateUI();
  };

  formatResponse = (response) => {
    console.log("formatResponse", response);
    try {
      // Tolerate a reply wrapped in a ```json code block or with a sentence
      // around the list — a strict JSON.parse of the raw text made the whole
      // search fail with "Error retrieving or parsing search results".
      const cleaned = String(response).replace(/```json\s*/gi, "").replace(/```/g, "").trim();
      let sched;
      try {
        sched = JSON.parse(cleaned);
      } catch (e) {
        const list = cleaned.match(/\[[\s\S]*\]/);
        if (!list) throw e;
        sched = JSON.parse(list[0]);
      }
      let sched_tex = "";
      let itinArray = null;
      if (Array.isArray(sched)) itinArray = sched;
      else {
        const keys = Object.keys(sched);
        let _itin = [];
        for (let k = 0; k < keys.length; k++) {
          let _array = sched[keys[k]];
          if (Array.isArray(_array))
            for (let x = 0; x < _array.length; x++) {
              _array[x].Date = keys[k];
              _itin.push(_array[x]);
            }
          else _itin.push(_array);
        }
        itinArray = _itin;
      }
      for (let i = 0; i < itinArray.length; i++) {
        sched_tex += `${itinArray[i].Attraction}\n`;
        sched_tex += `${itinArray[i].Category}\n`;
        //sched_tex += `${itinArray[i].Duration}\n`;
        sched_tex += `${itinArray[i].Description}\n\n`;
      }
      return { sched_tex: sched_tex, sched_json: itinArray };
    } catch (e) {
      this.MyAlert("Alert", "Error retrieving or parsing search results");
      return "";
    }
  };

  // Looks up every AI suggestion in parallel and calls Finish() exactly once,
  // when all of them have reported back (matched or not). Replaces an older
  // "delay the last lookup 2s and finish when it returns" guess, which lost
  // any place whose lookup was slower than the last one.
  findAllLatLongs = (places) => {
    const run = {};
    this._lookupRun = run;
    this._placesFound = [];
    this._pendingLookups = places.length;
    this.setState({ PlacesFound: this._placesFound });
    // Safety ceiling in case a lookup never calls back at all.
    setTimeout(() => {
      if (this._lookupRun === run) this._finishLookups();
    }, 60000);
    for (let i = 0; i < places.length; i++) {
      const target = this._lookupTarget(places[i]);
      this.googleTextSearch(target.text, false, places[i], target.bias);
    }
  };

  // The AI returns each suggestion's City; look it up "near" the dialog's
  // city (with location bias) only when it IS that city — otherwise a typed
  // "…in Milan Italy" with Florence selected searched for Milan's sights
  // around Florence and found nothing. Found 2026-10-08.
  _lookupTarget = (place) => {
    const selected = (this.state.selectedCity || "").trim().toLowerCase();
    const city = (place.City || "").trim();
    const sameCity = city === "" || selected === "" || city.toLowerCase().includes(selected) || selected.includes(city.toLowerCase());
    return sameCity
      ? { text: `${place.Attraction}, near ${this.state.selectedCity} ${this.state.selectedCountry}`, bias: true }
      : { text: `${place.Attraction}, ${city}`, bias: false };
  };

  _lookupDone = () => {
    this._pendingLookups -= 1;
    if (this._pendingLookups <= 0) this._finishLookups();
  };

  _finishLookups = () => {
    if (this._lookupRun == null) return;
    this._lookupRun = null;
    this.Finish();
  };

  items = [
    // {
    //   label: "Florence in Italy.",
    //   params: "City",
    // },
    {
      label: "Top 10 golf courses to visit in Florence Italy.",
      params: "City",
    },
    {
      label: "Top 10 attractions to visit in Florence Italy.",
      params: "City",
    },
    {
      label: "Top 10 viewpoints to visit in Florence Italy.",
      params: "City",
    },
    {
      label: "Top 10 restaurants in Florence Italy.",
      params: "City",
    },
    {
      label: "Top 10 attractions to visit outside of Florence Italy.",
      params: "City",
    },
    {
      label: "Top 10 day trips from Florence Italy.",
      params: "City",
    },
    {
      label: "Top 10 cities to visit near Florence Italy.",
      params: "City",
    },
    {
      label: "Top 10 towns to visit near Florence Italy.",
      params: "City",
    },
    {
      label: "Top 10 beaches near Florence Italy.",
      params: "City",
    },
    {
      label: "Top 10 neighborhoods to stay in Florence Italy.",
      params: "City",
    },
    {
      label: "Top 10 cities to visit in Italy.",
      params: "Country",
    },
    {
      label: "Top 10 towns to visit in Italy.",
      params: "City",
    },
    {
      label: "Top 10 attractions to visit in Italy.",
      params: "City",
    },
    {
      label: "Top 10 scenic drives near Florence Italy.",
      params: "City",
    },
    {
      label: "Top 10 outdoor experiences near Florence Italy.",
      params: "City",
    },
    {
      label: "Top 10 museums in Florence Italy.",
      params: "City",
    },
    {
      label: "Top 10 parks in Florence Italy.",
      params: "City",
    },
    {
      label: "Top 10 historical sites near Florence Italy.",
      params: "City",
    },
    {
      label: "Top 10 parks near Florence Italy.",
      params: "City",
    },
    {
      label: "Top 10 churches near Florence Italy.",
      params: "City",
    },
    {
      label: "Top 10 squares near Florence Italy.",
      params: "City",
    },
    {
      label: "Top 10 hiking trails near Florence Italy.",
      params: "City",
    },
    {
      label: "Top 10 castles near Florence Italy.",
      params: "City",
    },
    {
      label: "Top 10 must-see attractions in Florence Italy.",
      params: "City",
    },
    {
      label: "Top 10 hidden gems in Florence Italy.",
      params: "City",
    },
    {
      label: "Top 10 local favorites in Florence Italy.",
      params: "City",
    },
    {
      label: "Top 10 photo spots in Florence Italy.",
      params: "City",
    },
    {
      label: "Top 10 local markets in Florence Italy.",
      params: "City",
    },
    {
      label: "Top 10 coffee shops in Florence Italy.",
      params: "City",
    },
    {
      label: "Top 10 street art and murals in Florence Italy.",
      params: "City",
    },
  ];
  handleSearChanged = (event) => {
    //console.log(event.target.value);
    this.setState({ SearchText: event.target.value });
  };

  handledCountryChanged = (event) => {
    this.setState({ selectedCountry: event.target.value });
  };

  onChangeStart = (event) => {
    const dateStart = Common.LuxonDateFromJSDate(event);
    this.setState({ ...this.state, dateStart: dateStart });
  };

  Next = (number) => {
    // if (number === 2) {
    //   this.setState({ ...this.state, wizardStep: (number += 1) });
    //   return;
    // }
    if (number === 1) {
      this.setState({ activityIndicator: true });
      // this.askQuestion(
      //   `latitude and longitude for ${this.state.selectedCity}, ${this.state.selectedCountry} in json format`,
      //   this.LatLongReceived
      // );

      // Pure geocoding-by-text-query (this.state.LatLong is still its "0,0"
      // init value at this point). Uses searchPlacesNewAPI
      // (provider-switchable, see PLACES_PROVIDER in Common.js) instead of
      // the old searchPlaces+getQuickDetails legacy pair — found while
      // scoping PLACES_PROVIDER coverage gaps, 2026-09-24.
      const _at = new GooglePlaces();
      _at.searchPlacesNewAPI(
        `${this.state.selectedCity}, ${this.state.selectedCountry}`,
        null, 0, 0, 50000,
        this.searchGooglePlaceLatLong
      );

      return;
    }
    if (number === 2) {
      this.setState({ activityIndicator: true });
      let type = this.state.mood === "standard" ? "" : this.state.mood;
      this.askQuestion(
        `${this.state.selectedNumber}-day ${type} schedule for ${this.state.selectedCity}, ${
          this.state.selectedCountry
        } starting on ${this.state.dateStart.toFormat(
          "LLL dd"
        )} in json format, with attributes: 'Date', 'Time', 'Attraction' and 'Description' for each entry`,
        this.scheduleReceived
      );
      // this.askQuestion(
      //   `detailed 48 hour ${type} Itinerary for ${this.state.selectedCity}, ${this.state.selectedCountry}. Your response should in json format, with 3 parameters: 'Hour', 'Place' and 'Description'`,
      //   this.scheduleReceived
      // );
      return;
    }
    if (number === 3) {
      this.setState({ activityIndicator: true });

      let places = [];
      try {
        this.setState({ PlacesFound: [] });
        let sched = JSON.parse(this.state.Schedule);
        let itinArray = null;
        if (Array.isArray(sched)) itinArray = sched;
        else {
          // const keys = Object.keys(sched);
          // const itKey = keys[0];
          // itinArray = sched[itKey];
          // if (!Array.isArray(itinArray)) itinArray = Object.entries(itinArray);
          const keys = Object.keys(sched);
          let _itin = [];
          for (let k = 0; k < keys.length; k++) {
            let _array = sched[keys[k]];
            if (Array.isArray(_array))
              for (let x = 0; x < _array.length; x++) {
                _array[x].Date = keys[k];
                _itin.push(_array[x]);
              }
            else _itin.push(_array);
          }
          itinArray = _itin;
        }
        let places_to_find = [];
        for (let i = 0; i < itinArray.length; i++) {
          if (["Lunch", "Dinner", "Breakfast"].includes(itinArray[i].Attraction)) {
            //this.addEvent(itinArray[i], null)
            continue;
          }
          if (places.includes(itinArray[i].Attraction)) {
            //this.addEvent(itinArray[i], null)
            continue;
          }
          places_to_find.push(itinArray[i].Attraction);
        }
        for (let i = 0; i < places_to_find.length; i++) {
          // if (["Lunch", "Dinner", "Breakfast"].includes(sched[itKey][i].Attraction)) {
          //   if (i === sched[itKey].length - 1) {
          //     this.setState({ wizardStep: 4, PlacesArray: places, activityIndicator: false }); //this.props.onHide();
          //     continue;
          //   }
          // }
          // if (places.includes(sched[itKey][i].Attraction)) {
          //   if (i === sched[itKey].length - 1) {
          //     this.setState({ wizardStep: 4, PlacesArray: places, activityIndicator: false }); //this.props.onHide();
          //     continue;
          //   }
          // }
          places.push(places_to_find[i]);
          this.googleTextSearch(
            `${places_to_find[i]}, near ${this.state.selectedCity} ${this.state.selectedCountry}`,
            i === places_to_find.length - 1,
            places_to_find[i]
          );
        }
        this.setState({ PlacesArray: places_to_find });
      } catch (e) {
        this.MyAlert("Alert", "Error parsing schedule");
      }
      return;
    }
    // if (number === 4) {
    //   for(let i = 0; i < this.state.PlacesFound; i++){
    //     let place = this.state.PlacesFound[0];
    //     place.Category = [];
    //     window.guide_obj.places.addPlace(place);
    //   }
    //   return;
    // }
    this.setState({ wizardStep: this.state.wizardStep + 1 });
  };

  // searchPlacesNewAPI already returns parsed Place objects (unlike the old
  // searchPlaces, which needed a follow-up getQuickDetails pass) — this
  // just keeps the same error-on-empty behavior before handing off.
  searchGooglePlaceLatLong = (places) => {
    if (places === null || places.length === 0) {
      this.MyAlert("Alert", "Error retrieving latitude, longitude");
      this.setState({ activityIndicator: false });
      return;
    }
    this.searchGooglePlaceLatLongFinal(places);
  };

  searchGooglePlaceLatLongFinal = (places) => {
    if (places.length < 1) {
      this.setState({ activityIndicator: false });
      return;
    }
    this.setState({ LatLong: `${places[0].Lat},${places[0].Longi}`, wizardStep: 2, activityIndicator: false });
    setTimeout(() => this.Next(2), 200);
  };

  parseSched = () => {
    let scheduleName = `${this.state.selectedNumber}-day ${this.state.selectedCity}`;
    try {
      //let places = this.state.PlacesFound;
      let sched = JSON.parse(this.state.Schedule);
      let itinArray = null;
      if (Array.isArray(sched)) itinArray = sched;
      else {
        // const keys = Object.keys(sched);
        // const itKey = keys[0];
        // itinArray = sched[itKey];
        // if (!Array.isArray(itinArray)) itinArray = Object.entries(itinArray);
        const keys = Object.keys(sched);
        let _itin = [];
        for (let k = 0; k < keys.length; k++) {
          let _array = sched[keys[k]];
          if (Array.isArray(_array))
            for (let x = 0; x < _array.length; x++) {
              _array[x].Date = keys[k];
              _itin.push(_array[x]);
            }
          else _itin.push(_array);
        }
        itinArray = _itin;
      }
      let dayNum = 0;
      let DateLabel = "XXXXX";
      if (itinArray.length > 0) {
        if (
          typeof itinArray[0].Time === "undefined" ||
          typeof itinArray[0].Attraction === "undefined" ||
          typeof itinArray[0].Description === "undefined"
        ) {
          this.MyAlert("Alert", "Data is not in expected format go back and try again");
          this.setState({ activityIndicator: false });
          return;
        }
      }
      for (let i = 0; i < itinArray.length; i++) {
        let event = new Appointment(window.guide_obj.schedule);
        event.Subject = itinArray[i].Attraction;
        event.Body = itinArray[i].Description;

        // const placeIndex = places.findIndex((x) => x.Name === itinArray[i].Attraction);
        // if (placeIndex !== -1) event.Places = places[placeIndex].ID;

        let existing_place = window.guide_obj.places.getPlacesFromName(itinArray[i].Attraction);
        if (existing_place !== null) event.Places = existing_place.ID;
        event.Itinerary = scheduleName;
        if (DateLabel !== itinArray[i].Date) {
          dayNum += 1;
          DateLabel = itinArray[i].Date;
        }
        // let day = itinArray[i].Day;
        // let dayParts = day.split(" ");
        // try {
        //   if (dayParts[0] === "Day") dayNum = parseInt(dayParts[1]);
        // } catch (e) {}

        let time = itinArray[i].Time;
        let timeParts = time.split(":");
        let hour = parseInt(timeParts[0]);
        if (timeParts[1].includes("pm") && hour < 12) hour += 12;
        hour = hour + (dayNum - 1) * 24;
        event.Start = this.state.dateStart;
        event.Start = event.Start.set({ hour: hour });
        let eventDuration = 1;
        if (i < itinArray.length - 1) {
          let time = itinArray[i + 1].Time;
          let timeParts2 = time.split(":");
          let hour2 = parseInt(timeParts2[0]);
          if (timeParts[1].includes("pm") && hour2 < 12) hour2 += 12;
          hour2 = hour2 + (dayNum - 1) * 24;
          eventDuration = hour2 - hour;
        }
        event.End = this.state.dateStart;
        event.End = event.End.set({ hour: hour + eventDuration });
        window.guide_obj.schedule.addEvent(event);
      }
    } catch (e) {
      this.MyAlert("Alert", "Error parsing schedule. Fix json or go back and try again");
      this.setState({ activityIndicator: false });
    }
  };

  addEvent = (schedEntry, ID) => {
    let event = new Appointment(window.guide_obj.schedule);
    event.Subject = schedEntry.Place;
    event.Body = schedEntry.Description;
    let time = schedEntry.Time;
    let timeParts = time.split(":");
    let hour = parseInt(timeParts[0]);
    event.Start = this.state.dateStart;
    event.Start = event.Start.set({ hour: hour });
    event.End = this.state.dateStart;
    event.End = event.End.set({ hour: hour + 1 });
    if (ID !== null) event.Places = ID;
    event.Itinerary = `${this.state.selectedNumber}-day ${this.state.selectedCity}`;
    window.guide_obj.schedule.addEvent(event);
  };

  LatLongReceived = (latLong) => {
    try {
      let ll = JSON.parse(latLong);
      if (typeof ll.lat === "undefined") {
        if (typeof ll.latitude === "undefined") {
          this.MyAlert("Alert", "Error retrieving latitude, longitude");
          this.setState({ activityIndicator: false });
          return;
        } else this.setState({ LatLong: `${ll.latitude},${ll.longitude}`, wizardStep: 2, activityIndicator: false });
      }
      this.setState({ LatLong: `${ll.lat},${ll.lng}`, wizardStep: 2, activityIndicator: false });
      setTimeout(() => this.Next(2), 200);
    } catch (e) {
      this.MyAlert("Alert", "Error retrieving latitude, longitude");
      this.setState({ activityIndicator: false });
    }
  };

  scheduleReceived = (schedule) => {
    try {
      let sched = JSON.parse(schedule);
      let sched_tex = "";
      let date_text = "XXXXXX";
      let itinArray = null;
      if (Array.isArray(sched)) itinArray = sched;
      else {
        const keys = Object.keys(sched);
        let _itin = [];
        for (let k = 0; k < keys.length; k++) {
          let _array = sched[keys[k]];
          if (Array.isArray(_array))
            for (let x = 0; x < _array.length; x++) {
              _array[x].Date = keys[k];
              _itin.push(_array[x]);
            }
          else _itin.push(_array);
        }
        itinArray = _itin;
      }
      for (let i = 0; i < itinArray.length; i++) {
        if (itinArray[i].Date !== date_text) {
          date_text = itinArray[i].Date;
          sched_tex += `${itinArray[i].Date}\n`;
        }
        sched_tex += `${itinArray[i].Time}: `;
        sched_tex += `${itinArray[i].Attraction}\n`;
        sched_tex += `${itinArray[i].Description}\n\n`;
      }
      this.setState({ Schedule: schedule, ScheduleText: sched_tex, wizardStep: 3, activityIndicator: false });
      setTimeout(() => this.Next(3), 200);
    } catch (e) {
      this.MyAlert("Alert", "Error retrieving or parsing schedule");
      this.setState({ activityIndicator: false });
    }
  };

  Previous = (number) => {
    this.setState({ wizardStep: this.state.wizardStep - 1 });
  };

  Cancel = () => {
    this.props.onHide();
  };

  Finish = () => {
    const total = this.state.PlacesFound.length;
    if (total === 0) {
      // Nothing matched a real place — previously the spinner stayed on
      // forever here because the loop below never reaches updateUI().
      if (this.props.autoQuestion) {
        this.updateUI();
        return;
      }
      if (this._customSearch) {
        this._noCustomResults();
        return;
      }
      this.setState({ activityIndicator: false, statusText: "" });
      this.MyAlert("None of the suggested places could be found on the map. Try a different question.");
      return;
    }
    this.setState({ activityIndicator: true, statusText: `Step 3 of 4: Adding places to your guide (0 of ${total})…` });
    for (let i = 0; i < this.state.PlacesFound.length; i++) {
      let place = this.state.PlacesFound[i];
      let existing_place = this.props.find_search_result(this.state.PlacesFound[i].Name);
      if (existing_place === null) {
        this.props.add_search_result(place);
        this.setState({ statusText: `Step 3 of 4: Adding places to your guide (${i + 1} of ${total})…` });
        const isLast = i === this.state.PlacesFound.length - 1;
        // searchPlacesNewAPI (upstream, googleTextSearch) may already have
        // populated a real photo when PLACES_PROVIDER_ORDER's active
        // provider is hasdata/openwebninja (parseHasDataPlace/
        // parseOpenWebNinjaPlace set it directly from the vendor's own
        // listing photo) — hasRealPhoto skips the whole searchGoogleImages
        // call (paid lookup + free fallback chain) entirely in that case,
        // reusing what's already there via the same finalCallback path a
        // real fetch would have used, instead of paying for a second photo
        // lookup for data already in hand. TripAI.js's identical Finish()
        // loop already does this; found missing here 2026-09-26 auditing
        // search-then-enrich skip logic.
        if (hasRealPhoto(place)) {
          const finalCallback = isLast ? this.processGoogleImagesLast : this.processGoogleImages;
          setTimeout(() => finalCallback([{ url: place.Photo, url_m: place.Photo_m }], place.ID), 200);
        } else {
          setTimeout(
            () =>
              this.searchGoogleImages(
                `${this.state.PlacesFound[i].Name} near ${this.state.selectedCity}, ${this.state.selectedCountry}`,
                place.ID,
                isLast,
                `${this.state.PlacesFound[i].Name} ${this.state.selectedCity} ${this.state.selectedCountry}`.trim(),
                place.Lat,
                place.Longi
              ),
            200
          );
        }
      } else {
        if (i === this.state.PlacesFound.length - 1)
          setTimeout(() => {
            this.updateUI();
          }, 3000);
      }
    }
  };

  // Tried first now that OpenWeb Ninja/HasData is a paid subscription
  // (PLACES_PROVIDER, matching PlaceMenu.js's _autoSetPhotoSearch); falls
  // through to the pre-existing Custom Search call on a miss. paidQuery/lat/
  // lng are optional so existing callers (map-area flow above already
  // handles its own paid call separately) still work unmodified. Added
  // 2026-09-24.
  searchGoogleImages = (searchString, place_id, last, paidQuery, lat, lng) => {
    this.setState({ statusText: "Step 4 of 4: Fetching photos for your places…" });
    const finalCallback = last ? this.processGoogleImagesLast : this.processGoogleImages;
    const runFallback = () => {
      if (last) setTimeout(() => GoogleSearch.searchImages(searchString, finalCallback, place_id), 2000);
      else GoogleSearch.searchImages(searchString, finalCallback, place_id);
    };
    if (!paidQuery) {
      runFallback();
      return;
    }
    const paidSource = GooglePlaces.getPhotoProviderChain();
    paidSource.searchPlacePhoto(paidQuery, (photo) => {
      if (photo) {
        finalCallback([{ url: photo, url_m: photo }], place_id);
        return;
      }
      runFallback();
    }, lat, lng);
  };

  processGoogleImages = (imageList, place_id) => {
    if (imageList.length === 0) {
      console.log("AISearch: processGoogleImages: error");
      return;
    }
    console.log("AISearch: processGoogleImages: success");
    //let place = window.guide_obj.places.getPlace(place_id);
    let place = this.props.find_search_result(null, place_id);
    if (place === null) return;
    place.Photo = imageList[0].url;
    place.Photo_m = imageList[0].url_m;
    try {
      place.Info = Place.createImageHTML(Place.proxyImageUrl(place.Photo_m), null, "medium", null, place.Photo) + place.Info;
    } catch (e) {}
  };

  processGoogleImagesLast = (imageList, place_id) => {
    if (imageList.length === 0) {
      console.log("AISearch: processGoogleImagesLast: error");
      setTimeout(() => {
        this.updateUI();
      }, 1000);
      return;
    }
    console.log("AISearch: processGoogleImagesLast: success");
    //let place = window.guide_obj.places.getPlace(place_id);
    let place = this.props.find_search_result(null, place_id);
    if (place !== null) {
      place.Photo = imageList[0].url;
      place.Photo_m = imageList[0].url_m;
      try {
        place.Info = Place.createImageHTML(Place.proxyImageUrl(place.Photo_m), null, "medium", null, place.Photo) + place.Info;
      } catch (e) {}
    }

    //this.parseSched();
    setTimeout(() => {
      this.updateUI();
    }, 1000);
  };

  updateUI = () => {
    //let scheduleName = `${this.state.selectedNumber}-day ${this.state.selectedCity}`;
    //if (this.props.set_schedule_name !== null) this.props.set_schedule_name(scheduleName);
    //this.props.add_search_results(this.state.PlacesFound);
    this.props.update_ui();
    this.setState({ activityIndicator: false, statusText: "" });
    this.props.onHide();
  };

  // Uses searchPlacesNewAPI (provider-switchable, see PLACES_PROVIDER in
  // Common.js) instead of the old searchPlaces+getQuickDetails legacy pair
  // — found while scoping PLACES_PROVIDER coverage gaps, 2026-09-24.
  // searchPlacesNewAPI's callback is `(places) => {}`, one arg — `label` is
  // captured via closure instead of round-tripped as a 2nd callback arg,
  // since getGoogleDetailsCallback(Last) genuinely read it (label.Attraction,
  // label.City, etc.), unlike some of this file's other callback chains.
  // aiCategories/aiBaseCategories now thread all the way through to
  // parseNewAPIPlace, so Category is a real resolved guide ID by the time
  // it reaches getGoogleDetailsCallback(Last)'s `alreadyCategorized` check
  // (added earlier this session) — matching what the legacy path's
  // parsePlace already did.
  googleTextSearch = (searchText, last, label, bias = true) => {
    const _at = new GooglePlaces();
    const [lat, lng] = bias ? `${this.state.LatLong}`.split(",").map(Number) : [null, null];
    _at.searchPlacesNewAPI(searchText, null, lat, lng, 10000, (places) => this.searchGooglePlaceCallback(places, label), false, this.state.AICategories, this.state.AIBaseCategories);
  };

  // searchPlacesNewAPI already returns parsed Place objects — no follow-up
  // getQuickDetails pass needed.
  searchGooglePlaceCallback = (places, label) => {
    // An AI suggestion with no real match is skipped (unverified places are
    // never added). Previously this reset PlacesFound to [] and stopped the
    // spinner, wiping places other parallel lookups had already found.
    if (places == null || places.length == 0) {
      console.log("searchGooglePlaceCallback: no match, skipped", label.Attraction);
    } else {
      this.getGoogleDetailsCallback(places, label);
    }
    this._lookupDone();
  };


  getGoogleDetailsCallback = (places, label) => {
    //console.log("getGoogleDetailsCallback", places);
    if (places.length < 1) {
      console.log("getGoogleDetailsCallback: error", label.Attraction);
      return;
    }
    console.log("getGoogleDetailsCallback: success", label.Attraction);
    let places_found = this._placesFound || this.state.PlacesFound;
    let placeFound = places[0];
    // parsePlace (via getQuickDetails, now passed AICategories/
    // AIBaseCategories — 2026-09-24) already resolved a real Category from
    // the matched place's own Google types when one was found — a far more
    // reliable signal than GPT's own free-text guess (label.Category,
    // matched below). Only fall back to the "53"/guess-based path when
    // that came back empty. Found investigating real "category not found"
    // reports.
    const alreadyCategorized = Array.isArray(placeFound.Category) && placeFound.Category.length > 0;
    try {
      placeFound.Info += label.Description;
      placeFound.City = label.City;
      placeFound.Country = this.state.selectedCountry;
      placeFound.Group = ["20"];
      let found = alreadyCategorized;
      if (!found) {
        placeFound.Category = ["53"];
        for (let i = 0; i < this.state.AICategories.length; i++) {
          if (this.state.AICategories[i].category === label.Category) {
            placeFound.Category = [this.state.AICategories[i].id];
            found = true;
            break;
          }
        }
        if (!found) {
          for (let i = 0; i < this.state.AIBaseCategories.length; i++) {
            if (Common.tokenSubstringMatch(this.state.AIBaseCategories[i].category, label.Category)) {
              placeFound.Category = [this.state.AIBaseCategories[i].id];
              found = true;
              break;
            }
          }
        }
      }
      if (!found) console.log(`Category not found: ${label.Category}`);
    } catch (e) {}
    placeFound.Duration = Place.parseDuration(label.Duration);
    applyAIBestTime(placeFound, label.BestTime); // never over a BestTime the place already has
    places_found.push(placeFound);
    this.setState({
      PlacesFound: places_found,
      statusText: `Step 2 of 4: Looking up place details (${places_found.length} of ${this.state.totalPlacesToFind})…`,
    });
    this._fetchOpeningHoursInBackground(placeFound);
  };


  // AI Search only adds places to the guide — it doesn't build a schedule
  // itself (TripAI.js does), so this is lower-stakes here than there: no
  // schedule exists yet for a conflict to hide in. But whatever schedule
  // gets built later from these places (Build Trip from Places, the
  // wizard, etc.) benefits the same way — Place.getOpeningHoursConflict can
  // only detect a conflict if the place has real opening-hours data, which
  // asking the AI for can't reliably provide (no way to verify it
  // considered hours, or got them right). Fire-and-forget: doesn't block
  // the place-adding pipeline, since a slower network response here
  // shouldn't stall the rest of the search.
  _fetchOpeningHoursInBackground = (placeFound) => {
    // Skip when the place already has real hours (e.g. from OpenWeb
    // Ninja's search response, which attaches working_hours directly —
    // no separate call needed for that provider, unlike Google). Same
    // hasOpeningHoursData guard BuildMyTripWizard.js's enrichPlaceHours
    // already uses. Found 2026-09-24.
    if (GooglePlaces.hasOpeningHoursData(placeFound.OpeningHours)) return;
    try {
      GooglePlaces.fetchOpeningHours(placeFound, (hours) => {
        if (hours) {
          placeFound.OpeningHours = hours;
          this.setState({ PlacesFound: this.state.PlacesFound });
        }
      });
    } catch (e) {
      // silently skip on error
    }
  };


  selectCountry = () => {
    let _countries = [];
    const countries_sorted = countries.sort();
    let id = 1;
    countries_sorted.forEach((country) =>
      _countries.push({
        label: country,
        name: country,
        value: country,
        id: (id++).toString(),
      })
    );
    this.MultiSelect(_countries, [], "uni", this.selectedCountry, "Select Country");
  };

  AI_SEARCH_CITY_OTHER = "__other__";

  // Country-first: if the country isn't picked yet, redirect there instead
  // of showing an empty/meaningless city list.
  selectCity = () => {
    const country = this.state.selectedCountry;
    if (!country) {
      this.selectCountry();
      return;
    }
    const cityList = (citiesByCountry[country] || []).slice().sort((a, b) => b.popularity - a.popularity);
    if (cityList.length === 0) {
      this._promptCityText();
      return;
    }
    const items = cityList.map((c, i) => ({ label: c.city, name: c.city, value: c.city, id: (i + 1).toString() }));
    items.push({ label: "Type a different city…", name: "other", value: this.AI_SEARCH_CITY_OTHER, id: (items.length + 1).toString() });
    this.MultiSelect(items, [], "uni", this.selectedCity, `Select a city in ${country}`);
  };

  selectedCity = (selected) => {
    if (!selected || selected.length === 0) return;
    if (selected[0].value === this.AI_SEARCH_CITY_OTHER) {
      this._promptCityText();
      return;
    }
    this.setState({ selectedCity: selected[0].value });
  };

  // Free-text fallback — for a country with no curated cities, or the
  // curated list's own "type a different city" escape hatch. No geocode
  // validation: this field also accepts non-geocodable entries like a
  // neighborhood or region, matching its existing lenient behavior.
  _promptCityText = () => {
    this.setState({
      PromptModalShow: true,
      PromptModalTitle: "City",
      PromptModalMessage: "Enter City",
      PromptModalButtons: [
        { Title: "OK", Method: this._promptCityTextCallBack },
        { Title: "CANCEL", Method: null },
      ],
      PromptModalInputs: [{ name: "City", value: this.state.selectedCity || "" }],
    });
  };

  _promptCityTextCallBack = (inputs) => {
    const city = (inputs?.[0]?.value || "").trim();
    if (city === "") return;
    this.setState({ selectedCity: city });
  };

  selectedCountry = (countries) => {
    let country = "";
    if (countries.length < 1) country = "";
    else country = countries[0].value;
    // Blanking the city on an actual country change (not a no-op reselect)
    // avoids leaving a stale city from the old country — city choices are
    // scoped to a country.
    const cityChanged = country !== this.state.selectedCountry;
    this.setState({ selectedCountry: country, selectedCity: cityChanged ? "" : this.state.selectedCity });
  };

  proximityChanged = (e) => {
    this.setState({ proximity: e.target.value });
  };

  MultiSelect = (Items, SelectedItems, Mode, Callback, Title) => {
    //console.log("MultiSelect");
    this.setState({
      MultiselectItems: Items,
      MultiselectSelectedItems: SelectedItems,
      MultiselectMode: Mode,
      MultiselectCallback: Callback,
      MultiselectTitle: Title,
      MultiselectSearchText: "",
      ShowMultiselect: true,
    });
  };

  render() {
    //let questions = JSON.parse(JSON.stringify(this.items));
    //console.log("this.props.questions", this.props.questions);
    let questions = [];
    try {
      questions = JSON.parse(this.props.questions);
    } catch (e) {
      questions = JSON.parse(JSON.stringify(this.items));
      //questions = [];
      console.log("error parsing JSON this.props.questions", e);
    }

    // try {
    //   questions = JSON.parse(this.props.questions);
    // } catch (e) {
    //   questions = [];
    //   console.log("error parsing JSON this.props.questions", e);
    // }
    // if (this.props.user_info.uid === "E2Fqqu9FWDgTdpOzdKQOKEdo6wA3") {
    //   questions.push({
    //     label: "10-day itinerary for Florence Italy in json format with: time, place and description",
    //     params: "City",
    //   });
    //   questions.push({
    //     label: "Which cities to visit in Italy, for how many days and in which order, for a 10-day trip",
    //     params: "City",
    //   });
    // }

    questions = questions.sort((a, b) => (a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1));
    // let destination = this.state.selectedCity;
    // let country = `${this.state.selectedCountry}`;
    // if (this.state.place !== null) {
    //   destination = `${this.state.place.Name}, ${this.state.selectedCity}`;
    // }
    // if (this.state.location !== null) {
    //   destination = `${this.state.location.Lat.toFixed(6)},${this.state.location.Longi.toFixed(6)}`;
    //   country = "";
    // }
    //console.log("this.state.selectedNumber", this.state.selectedNumber);
    let _questions = [];
    const isMapArea = this.state.searchArea === "map";
    const seenMapLabels = new Set();
    for (let i = 0; i < questions.length; i++) {
      if (this.state.place === null && questions[i].params === "Place") continue;
      // These name a wider region (other cities/towns, trips away from the
      // destination, "outside of" it) — meaningless once the location is
      // "whatever's in the current map viewport" instead of a whole city, so
      // they're hidden in map-area mode rather than turned into nonsense.
      if (isMapArea && /\b(cities|towns) to visit\b|day trips from|outside of/i.test(questions[i].label)) continue;
      if (isMapArea)
        // No geocoding needed for map-area mode — the bounding box already
        // scopes the search, so the trailing "in/near/outside of Florence
        // Italy" clause is just dropped rather than replaced with filler
        // text (e.g. "Top 10 churches in Florence Italy." -> "Top 10
        // churches"). The real bounding-box constraint is appended to the
        // actual AI prompt separately — see _askMapAreaQuestion.
        questions[i].label = questions[i].label
          .replace(/\s+(?:to \w+\s+)?(?:in|near)\s+Florence Italy\.?$/i, "")
          .replace(/\s+(?:to \w+\s+)?in\s+Italy\.?$/i, "")
          .replace("10", this.state.selectedNumber);
      else if (questions[i].label.includes("Florence"))
        questions[i].label = questions[i].label
          //.replace("Florence ", this.state.selectedCity)
          .replace("Florence", this.state.selectedCity)
          .replace("Italy", this.state.selectedCountry)
          .replace("10", this.state.selectedNumber)
          .replace(" in ", ` ${this.state.proximity} `);
      else
        questions[i].label = questions[i].label
          //.replace("Florence ", this.state.selectedCity)
          .replace("Florence", this.state.selectedCity)
          .replace("Italy", this.state.selectedCountry)
          .replace("10", this.state.selectedNumber);
      if (
        this.state.SearchText !== "" &&
        !questions[i].label.toUpperCase().includes(this.state.SearchText.toUpperCase())
      )
        continue;
      // Dropping the location clause in map mode can make two originally-
      // distinct questions collapse to the same text (e.g. "...parks in..."
      // and "...parks near..." both become "Top 10 parks") — keep only the
      // first so the list doesn't show visible duplicates.
      if (isMapArea) {
        if (seenMapLabels.has(questions[i].label)) continue;
        seenMapLabels.add(questions[i].label);
      }
      _questions.push(questions[i]);
    }
    //console.log("_questions", _questions);
    if (this.state.AlertModalShow)
      return (
        <AlertModal
          show={this.state.AlertModalShow}
          onHide={() => this.setState({ AlertModalShow: false })}
          AlertModalTitle={this.state.AlertModalTitle}
          AlertModalMessage={this.state.AlertModalMessage}
          AlertModalButtons={this.state.AlertModalButtons}
        />
      );
    if (this.state.PromptModalShow)
      return (
        <PromptModal
          show={this.state.PromptModalShow}
          onHide={() => this.setState({ PromptModalShow: false })}
          PromptModalTitle={this.state.PromptModalTitle}
          PromptModalMessage={this.state.PromptModalMessage}
          PromptModalButtons={this.state.PromptModalButtons}
          PromptModalInputs={this.state.PromptModalInputs}
        />
      );
    if (this.state.ShowMultiselect)
      return (
        <MultiSelectModal
          show={this.state.ShowMultiselect}
          onHide={() => this.setState({ ShowMultiselect: false })}
          MultiselectItems={this.state.MultiselectItems}
          MultiselectSelectedItems={this.state.MultiselectSelectedItems}
          MultiselectMode={this.state.MultiselectMode}
          MultiselectCallback={this.state.MultiselectCallback}
          MultiselectTitle={this.state.MultiselectTitle}
          MultiselectSearchText={this.state.MultiselectSearchText}
        />
      );
    // Auto-fired (wizard) case — the user never interacts with this, so
    // skip the whole Destination/Options/Question UI and show only the
    // progress indication. Matches mobile's headless AiSearch mode.
    if (this.props.autoQuestion) {
      return (
        <div className="modal">
          <Modal
            show={this.props.show}
            onHide={this.props.onHide}
            animation={false}
            dialogClassName="aid-dialog aid-dialog-headless"
            aria-labelledby="aid-title"
            centered
          >
            <Modal.Body style={{ padding: 0 }}>
              <div className="aid-shell">
                <div className="aid-body">
                  <div className="aid-loading">
                    <div className="aid-spinner" />
                    {this.state.statusText ? <p className="aid-note">{this.state.statusText}</p> : null}
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      );
    }

    const { optionsOpen } = this.state;

    return (
      <div className="modal">
        <Modal
          {...this.props}
          animation={false}
          dialogClassName="aid-dialog"
          aria-labelledby="aid-title"
          centered
          onHide={this.props.onHide}
        >
          <Modal.Body style={{ padding: 0 }}>
            <div className="aid-shell">

              {/* ── Header ── */}
              <div className="aid-header">
                <div className="aid-header-icon">
                  <FontAwesomeIcon icon={icoRobot} />
                </div>
                <h2 className="aid-title" id="aid-title">Search for Places using AI</h2>
                <input
                  className="aid-filter"
                  type="text"
                  placeholder="Filter questions…"
                  value={this.state.SearchText}
                  onChange={this.handleSearChanged}
                />
                <button className="aid-close" onClick={() => this.props.onHide()}>
                  <FontAwesomeIcon icon={solid("xmark")} />
                </button>
              </div>

              {/* ── Scrollable body ── */}
              <div className="aid-body" ref={(r) => (this._bodyRef = r)}>

                <p className="aid-note">Note: this can take 30+ seconds</p>

                {/* Describe what you're looking for (free text) */}
                <span className="aid-section-label">Describe what you're looking for</span>
                <div className="aid-card">
                  <div className="aid-ask">
                    <input
                      className="aid-ask-input"
                      type="text"
                      maxLength={200}
                      placeholder="e.g. romantic restaurants with a view"
                      value={this.state.customSearch}
                      onChange={(e) => this.setState({ customSearch: e.target.value })}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") this.runCustomSearch();
                      }}
                    />
                    <button
                      className="aid-ask-btn"
                      onClick={this.runCustomSearch}
                      disabled={this.state.customSearch.trim() === "" || this.state.activityIndicator}
                    >
                      Search
                    </button>
                  </div>
                </div>

                {/* Loading */}
                {this.state.activityIndicator && (
                  <div className="aid-loading">
                    <div className="aid-spinner" />
                    {this.state.statusText ? (
                      <p className="aid-note" style={{ marginTop: 8 }}>{this.state.statusText}</p>
                    ) : null}
                  </div>
                )}

                {/* Response — right under the search box so it's seen without scrolling. */}
                {this.state.answer ? (
                  <>
                    <span className="aid-section-label">Response</span>
                    <textarea className="aid-textarea" value={this.state.answer} readOnly />
                  </>
                ) : null}


                {this.props.mapBounds ? (
                  <>
                    <span className="aid-section-label">Search area</span>
                    <div className="aid-card" style={{ display: "flex", padding: 4 }}>
                      <button
                        className={`aid-mode-btn${this.state.searchArea === "map" ? " active" : ""}`}
                        onClick={() => this.setState({ searchArea: "map" })}
                      >
                        Current map view
                      </button>
                      <button
                        className={`aid-mode-btn${this.state.searchArea === "place" ? " active" : ""}`}
                        onClick={() => this.setState({ searchArea: "place" })}
                      >
                        City / Place
                      </button>
                    </div>
                  </>
                ) : null}

                {/* Options */}
                <span className="aid-section-label">Options</span>
                <div className="aid-card">
                  <button
                    className="aid-options-toggle"
                    onClick={() => this.setState({ optionsOpen: !optionsOpen })}
                  >
                    <span className="aid-options-toggle-label">Customise query</span>
                    <FontAwesomeIcon
                      className="aid-options-toggle-icon"
                      icon={optionsOpen ? icoChevUp : icoChevDown}
                    />
                  </button>

                  {optionsOpen && (
                    <div className="aid-options-body">
                      <div className="aid-divider" />
                      <div className="aid-row">
                        <span className="aid-row-label">Number</span>
                        <select
                          className="aid-select"
                          onChange={this.numberChanged}
                          defaultValue={this.state.selectedNumber}
                        >
                          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 20].map((n) => (
                            <option key={n} value={n}>{n}</option>
                          ))}
                        </select>
                      </div>
                      {this.state.searchArea !== "map" && (
                        <>
                          <div className="aid-divider" />
                          <div className="aid-row">
                            <span className="aid-row-label">Proximity</span>
                            <select
                              className="aid-select"
                              onChange={this.proximityChanged}
                              defaultValue={this.state.proximity}
                            >
                              {["in", "near", "in or near", "outside of", "within 1 hour from", "within 2 hours from", "within 3 hours from"].map((p) => (
                                <option key={p} value={p}>{p}</option>
                              ))}
                            </select>
                          </div>
                          <div className="aid-divider" />
                          <div className="aid-row">
                            <span className="aid-row-label">Country</span>
                            <span className="aid-country-val">{this.state.selectedCountry}</span>
                            <button className="aid-country-btn" onClick={() => this.selectCountry()}>
                              Change
                            </button>
                          </div>
                          <div className="aid-divider" />
                          {/* Picks from the selected country's curated city list, with a
                              "type a different city" fallback — see selectCity(). */}
                          <div className="aid-row">
                            <span className="aid-row-label">City / place</span>
                            <span className="aid-country-val">{this.state.selectedCity}</span>
                            <button className="aid-country-btn" onClick={() => this.selectCity()}>
                              Change
                            </button>
                          </div>
                        </>
                      )}
                      <div className="aid-divider" />
                      <div className="aid-row">
                        <span className="aid-row-label" style={{ flex: 1, minWidth: 0 }}>Exclude places in guide from results</span>
                        <span
                          className={`aid-toggle${this.state.excludeGuidePlaces ? " on" : ""}`}
                          onClick={() => this.setState({ excludeGuidePlaces: !this.state.excludeGuidePlaces })}
                        />
                      </div>
                    </div>
                  )}
                </div>

                {/* Questions — usable in both modes; in map-area mode each
                    one runs restricted to the current map bounds instead of
                    a named city (see _askMapAreaQuestion). */}
                {/* Click fills the search box to edit; the arrow runs it as-is. */}
                <span className="aid-section-label">Sample queries</span>
                <div className="aid-card">
                  <ul className="aid-q-list">
                    {_questions.map((item, index) => (
                      <li
                        key={index}
                        className="aid-q-item aid-q-sample"
                        onClick={() => {
                          this.setState({ customSearch: item.label.replace(/\.$/, "") });
                          this._scrollToTop();
                        }}
                        title="Click to edit in the search box"
                      >
                        <span className="aid-q-text">{item.label}</span>
                        <button
                          className="aid-q-run"
                          title="Run this query"
                          aria-label={`Run: ${item.label}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.questionChanged({ target: { value: item.label } });
                          }}
                        >
                          <FontAwesomeIcon icon={solid("arrow-right")} />
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>

              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default AISearch;
